import React from "react";
import {
  Box,
  Grid,
  TextField,
  Autocomplete,
  Button,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { rows } from "./data";

const pickerNames = [...new Set(rows.map((row) => row.picker))];
const timePeriods = ["Today", "7 Days", "14 Days", "1 Month", "1 Year"];

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <InputLabel>Job No</InputLabel>
        <TextField
          variant="outlined"
          name="jobNo"
          value={filterData.jobNo}
          onChange={handleChangeFilter("jobNo")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <InputLabel>Cust Order</InputLabel>
        <TextField
          variant="outlined"
          name="custOrder"
          value={filterData.custOrder}
          onChange={handleChangeFilter("custOrder")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <InputLabel>Order Line (Min)</InputLabel>
        <TextField
          variant="outlined"
          name="orderLineMin"
          type="number"
          value={filterData.orderLineMin}
          onChange={handleChangeFilter("orderLineMin")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <InputLabel>Order Line (Max)</InputLabel>
        <TextField
          variant="outlined"
          name="orderLineMax"
          type="number"
          value={filterData.orderLineMax}
          onChange={handleChangeFilter("orderLineMax")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <InputLabel>Picker</InputLabel>
        <Autocomplete
          disablePortal
          options={pickerNames}
          value={filterData.picker}
          onChange={(_, newValue) => handleChangeFilter("picker")(newValue)}
          renderInput={(params) => <TextField {...params} variant="outlined" />}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <InputLabel>Time Period (Ordered Date)</InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.timePeriod}
            onChange={(e) => handleChangeFilter("timePeriod")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="">All</MenuItem>
            {timePeriods.map((period) => (
              <MenuItem key={period} value={period}>
                {period}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={6}>
        <InputLabel>Ordered Date Range</InputLabel>
        <Box display="flex" gap={2}>
          <DatePicker
            label="Start"
            value={filterData.orderedDateStart}
            onChange={handleChangeFilter("orderedDateStart")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
          <DatePicker
            label="End"
            value={filterData.orderedDateEnd}
            onChange={handleChangeFilter("orderedDateEnd")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <InputLabel>Order Loaded Range</InputLabel>
        <Box display="flex" gap={2}>
          <DateTimePicker
            label="Start"
            value={filterData.orderLoadedStart}
            onChange={handleChangeFilter("orderLoadedStart")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
          <DateTimePicker
            label="End"
            value={filterData.orderLoadedEnd}
            onChange={handleChangeFilter("orderLoadedEnd")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <InputLabel>Order Reached Bay Range</InputLabel>
        <Box display="flex" gap={2}>
          <DateTimePicker
            label="Start"
            value={filterData.orderReachedBayStart}
            onChange={handleChangeFilter("orderReachedBayStart")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
          <DateTimePicker
            label="End"
            value={filterData.orderReachedBayEnd}
            onChange={handleChangeFilter("orderReachedBayEnd")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <InputLabel>Order Marked Completed Range</InputLabel>
        <Box display="flex" gap={2}>
          <DateTimePicker
            label="Start"
            value={filterData.orderMarkedCompletedStart}
            onChange={handleChangeFilter("orderMarkedCompletedStart")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
          <DateTimePicker
            label="End"
            value={filterData.orderMarkedCompletedEnd}
            onChange={handleChangeFilter("orderMarkedCompletedEnd")}
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={3}>
        <InputLabel>Total Duration</InputLabel>
        <TextField
          variant="outlined"
          name="totalDuration"
          value={filterData.totalDuration}
          onChange={handleChangeFilter("totalDuration")}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleFilter();
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
